// tslint:disable
export enum ActivationAssignedStatus {
    /**
     * @description [Not Set]
     */
    NotSet = 0,
    /**
     * @description Call to Activate
     */
    CallToActivate = 41,
    /**
     * @description Issue and Activate
     */
    IssueAndActivate = 42,
    /**
     * @description Pre-active
     */
    PreActive = 99,
}
(ActivationAssignedStatus as any)['NOTSET'] = 0;
(ActivationAssignedStatus as any)['CALLTOACTIVATE'] = 41;
(ActivationAssignedStatus as any)['ISSUEANDACTIVATE'] = 42;
(ActivationAssignedStatus as any)['PREACTIVE'] = 99;
